import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { LangProvider } from "./lib/i18n";
import { Toaster } from "./components/ui/sonner";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import ProtectedRoute from "./components/ProtectedRoute";
import OnboardingDialog from "./components/OnboardingDialog";
import UserLanguageSync from "./components/UserLanguageSync";
import Landing from "./pages/Landing";
import Estimator from "./pages/Estimator";
import Devices from "./pages/Devices";
import DeviceDetail from "./pages/DeviceDetail";
import QuoteView from "./pages/QuoteView";
import AdminLogin from "./pages/AdminLogin";
import Register from "./pages/Register";
import AdminDashboard from "./pages/AdminDashboard";
import CombinedWizard from "./pages/CombinedWizard";
import "./App.css";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <UserLanguageSync />
          <SiteHeader />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/estimator" element={<ProtectedRoute requireAdminRole={false}><Estimator /></ProtectedRoute>} />
            <Route path="/wizard" element={<ProtectedRoute requireAdminRole={false}><CombinedWizard /></ProtectedRoute>} />
            <Route path="/devices" element={<ProtectedRoute requireAdminRole={false}><Devices /></ProtectedRoute>} />
            <Route path="/devices/:id" element={<ProtectedRoute requireAdminRole={false}><DeviceDetail /></ProtectedRoute>} />
            <Route path="/quote/:id" element={<QuoteView />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
          <SiteFooter />
          <OnboardingDialog />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
